// A photo or video Portal can go out with no words. Anything that would quote them says this instead.
export const NO_WORDS_HEADLINE = 'The Portal\u2019s open.';

export function openedLine(hostName) {
  const first = (hostName || '').trim().split(/\s+/)[0];
  return `${first || 'Someone'} opened a Portal`;
}
